import React from 'react'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  color?: string
  className?: string
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = '#3B82F6',
  className = '',
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8',
  }

  return (
    <div
      className={`
        animate-spin rounded-full border-2 border-transparent
        ${sizeClasses[size]}
        ${className}
      `}
      style={{
        borderTopColor: color,
        borderRightColor: color,
      }}
    />
  )
}

export default LoadingSpinner
